import { LoginType, MatchStatus } from 'components/types/Context'
import { useContext, useEffect, useMemo, useState } from 'react'
import { AppGeneralContext } from 'shared/GeneralContext/GeneralContext'
import { AskMatchMessage } from '../AskMatchMessage'
import { ChatMessage, Corporate, Message, StartUp } from '../../types/types'
import pinkIcon from '../../../assets/logo192.png'
import { MatchRequestMessage } from '../MatchRequestMessage'
import { DateMeetingMessage } from '../DateMeetingMessage'
import { SelectMeetingMessage } from '../SelectMeetingMessage'
import { AskNewAvailability } from '../AskNewAvailability'
import { DeclineMatchMessage } from '../DeclineMatchMessage'


interface MessageComponent {
  message: ChatMessage,
  startup?: StartUp,
  corporate?: Corporate
}


export const MessageComponent = ({
  message,
  startup,
  corporate
}: MessageComponent) => {

  const { baseUri } = useContext(AppGeneralContext)

  const messageDate = new Date(message.dateAction)
  const dayMessage = messageDate.getDay()
  const monthMessage = messageDate.getMonth()
  const yearMessage = messageDate.getFullYear()


  const showMessage = useMemo(() => {

    if (!startup || !corporate || !message.status) {
      return <></>
    }

    if (message.status === MatchStatus.StartupStartedMatch) {
      return <AskMatchMessage
        match={{
          id: message.matchId,
          status: MatchStatus.StartupStartedMatch,
          company: corporate,
          startup: startup,
          lastMessageDate: "",
          isReadStartup: false,
          isReadCompany: false
        }}
        name={startup.name}
        fromSender={message.fromSender}
        fromStartup={message.sentByStartup}
        StartupID={startup.id ? startup.id : ""}
        logoImg={startup.logoUrl && startup.logoUrl !== "" ? `${baseUri}${startup.logoUrl}` : pinkIcon}
        isOld={message.isOldMessage} />
    }


    if (message.status === MatchStatus.CompanySentAvailability && message.dateAval1 && message.dateAval2 && message.dateAval3 && !message.acceptedMatch) {
      return <MatchRequestMessage
        matchId={message.matchId}
        fromSender={message.fromSender}
        id={message.id}
        isOld={message.isOldMessage} />
    }

    if (message.status === MatchStatus.CompanySentAvailability && message.dateAval1 && message.dateAval2 && message.dateAval3 && message.acceptedMatch) {
      return <SelectMeetingMessage
        matchId={message.matchId}
        fromSender={message.fromSender}
        dates={[{ date: message.dateAval1 }, { date: message.dateAval2 }, { date: message.dateAval3 }]}
        isOld={message.isOldMessage} />
    }

    if (message.status === MatchStatus.StartupConfirmedMatch) {
      return <DateMeetingMessage date={message?.dateConfirmed ? message.dateConfirmed : ""} isOld={message.isOldMessage} />
    }

    if (message.status === MatchStatus.CompanyStartedMatch && message.dateAval1 && message.dateAval2 && message.dateAval3 && !message.acceptedMatch) {
      return <MatchRequestMessage
        matchId={message.matchId}
        fromSender={message.fromSender}
        id={message.id}
        isOld={message.isOldMessage} />
    }

    if (message.status === MatchStatus.CompanyStartedMatch && message.dateAval1 && message.dateAval2 && message.dateAval3 && message.acceptedMatch) {
      return <SelectMeetingMessage
        matchId={message.matchId}
        fromSender={message.fromSender}
        dates={[{ date: message.dateAval1 }, { date: message.dateAval2 }, { date: message.dateAval3 }]}
        isOld={message.isOldMessage} />
    }

    if (message.status === MatchStatus.StartupAskedNewAvailability) {
      return <AskNewAvailability
        name={startup.name}
        startupId = {startup.id!}
        fromSender={message.fromSender}
        isOld={message.isOldMessage} />
    }

    if (message.status === MatchStatus.CompanySentNewAvailability && message.dateAval1 && message.dateAval2 && message.dateAval3 && !message.acceptedMatch) {
      return <SelectMeetingMessage
        matchId={message.matchId}
        fromSender={message.fromSender}
        dates={[{ date: message.dateAval1 }, { date: message.dateAval2 }, { date: message.dateAval3 }]}
        isOld={message.isOldMessage} />
    }

    if (message.status === MatchStatus.StartupRefusedMatch) {
      return <DeclineMatchMessage
        name={startup.name}
        fromSender={message.fromSender}
        isOld={message.isOldMessage} />
    }

    if (message.status === MatchStatus.CompanyRefusedMatch) {
      return <DeclineMatchMessage
        name={corporate.name}
        fromSender={message.fromSender}
        isOld={message.isOldMessage} />
    }

    return null

  }, [message.status,
  message.acceptedMatch,
  message.dateAval1,
  message.dateAval2,
  message.dateAval3,
  message.isOldMessage,
  message.acceptedMatch,
    message,
  message.dateAction,
  message.dateConfirmed,
  message.fromSender,
  message.id,
  message.matchId,
  message.sentByStartup,
  message.showDate
  ])


  return showMessage


}


